interface FAQItem {
  question: string;
  answer: string;
}

interface FAQSectionProps {
  items: FAQItem[];
}

export default function FAQSection({ items }: FAQSectionProps) {
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: items.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };

  return (
    <section className="w-full max-w-3xl mx-auto px-4 md:px-6 py-10 md:py-14">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <div className="text-center mb-8">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
          常见问题
        </h2>
        <p className="mt-3 text-foreground-600 text-sm">快速了解国产精品在线</p>
      </div>
      <div className="space-y-3">
        {items.map((item, index) => (
          <details
            key={index}
            className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden cursor-pointer"
          >
            <summary className="flex items-center justify-between px-5 py-4 text-sm md:text-base font-medium text-foreground-800 hover:text-primary-600 transition-colors list-none">
              {item.question}
              <i className="ri-arrow-down-s-line text-lg text-foreground-400 group-open:rotate-180 transition-transform"></i>
            </summary>
            <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
              {item.answer}
            </div>
          </details>
        ))}
      </div>
    </section>
  );
}